import { LoadDoctorDocument } from 'domain/usecases/doctor/load-doctor-document'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteLoadDoctorDocument implements LoadDoctorDocument {
  constructor(private readonly doctorRepository: DoctorRepository) {}
  load(params: LoadDoctorDocument.Params): Promise<LoadDoctorDocument.Model> {
    return this.doctorRepository.loadDoctorDocument(params)
  }
}
